export default {
	"148948b5cdc037944bca63935fdeb8cd": "确认订单收银台-添加地址",
	"b19b7c16503a95e44c8e6b51162bbeae": "确认订单收银台-选择地址",
	"f8d4cb146e6407435ddab35663f9b64d": "暂无收货地址",
	"4895ae1b1fee46c1699af916adc1b797": "添加地址"
}
